import { StateServices } from "./i-state-services";
import { Action, ActionReducer, createSelector, MemoizedSelector } from "@ngrx/store";
import { runInInjectionContext } from "@angular/core";
import { filter } from "rxjs";
import { FunctionIsNotAllowed } from "./state-utils/instanceActionGroup";
import { Blueprint } from "../cyanprints/blueprint";
import { BlueprintEffectClass } from "./effect-class-blueprint";


export class InstanceState<TState, TActions extends Record<string, any>, TSelectors extends Record<string, any>, TBlueprint extends Blueprint> {

  public actions: TActions
  public selectors: TSelectors
  public stateId: string

  constructor(
    public entityId: string,
    public actionFn: (entityId: string) => TActions,
    public selectorFn: (entityId: string) => TSelectors,
    public effectClass: new (...args: any[]) => BlueprintEffectClass<TBlueprint>,
    public reducerFn: (actions$: TActions) => ActionReducer<TState, Action>,
    private stateServices: StateServices,
    private blueprintInstance: TBlueprint
  ) { 
    this.stateId = `${entityId}`
    this.actions = actionFn(this.stateId) 
    const reducer = reducerFn(this.actions)
    this.stateServices.reducerManager.addReducer(this.stateId, reducer);
    this.selectors = selectorFn(this.stateId);
    this.addEffectClass(effectClass, blueprintInstance)
  }

  public select<T>(
    selector: MemoizedSelector<object, T | undefined | null>,
  ) {
    return this.stateServices.store.select(selector).pipe(
      filter((v): v is T => v != null)
    );
  }

  public dispatch<V extends Action = Action>(action: V & FunctionIsNotAllowed<V, 'Functions are not allowed to be dispatched. Did you forget to call the action creator function?'>): void {
    // this.stateServices.store.dispatch(action as Action)
    this.stateServices.websocketService.dispatch(action as Action)
  }

  addEffectClass(eClass: any, blueprintInstance: TBlueprint) {
    const injector = this.stateServices.injector
    runInInjectionContext(injector, () => {
      let effects = new eClass(injector)
      effects.actions = this.actions as any
      effects.instance = blueprintInstance
      effects.constructor = {name: "Object"}
      this.stateServices.effectSources.addEffects(effects);
    })
  }
}
